import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import TextualContent from '../../TextualContent';
import { useDeviationViewContext } from '../../../Context';
import AutoSizedText from '../_partials/AutoSizedText';
import ClockIcon from '@wix/da-ds/pkg/Icons/24x24/Clock';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { getReadingTimeMinutes } from '../../Thumb/helpers';
import Timestamp from '../../../Timestamp';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getDeviationTitle } from '../../_helpers';
import s from './Journal.scss';
const JournalFullView = ({ deviation, width, height })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const { isFullscreen, isTheater } = useDeviationViewContext();
    const style = isTheater || isFullscreen || isMobile ? {
        width,
        height
    } : {
        width
    };
    const minutes = getReadingTimeMinutes(deviation.textContent);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isFullscreen && s['fullscreen']),
        style: style
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['content-wrap']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['title-wrap']
    }, /*#__PURE__*/ React.createElement(AutoSizedText, {
        className: s['title'],
        tooBigClassName: s['better-fit'],
        maxHeight: 180
    }, getDeviationTitle(deviation)), /*#__PURE__*/ React.createElement("div", {
        className: s['subtitle']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['published']
    }, /*#__PURE__*/ React.createElement(Timestamp, {
        timestamp: deviation.publishedTime
    })), !!minutes && /*#__PURE__*/ React.createElement("span", {
        className: s['read-time']
    }, /*#__PURE__*/ React.createElement(ClockIcon, {
        className: s['clock'],
        size: IconSize.SMALL,
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("span", null, t('deviationview.journal.stage.read', {
        count: minutes
    }))))), isFullscreen && /*#__PURE__*/ React.createElement(TextualContent, {
        deviation: deviation,
        withArtist: false
    })));
};
JournalFullView.displayName = 'JournalFullView';
export default JournalFullView;
